"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectPlan = exports.getProducts = void 0;
const api_1 = require("core/api");
const utils_1 = require("core/utils");
/* eslint-disable @typescript-eslint/ban-ts-comment */
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const useRequest_1 = require("src/hooks/useRequest");
const mocks_1 = require("../mocks");
const getDisplayPrices = (product) => {
    const displayPrices = {
        priceInCents: product.priceInCents,
        nonDiscountedPriceInCents: undefined,
    };
    if (product.discountedPriceInCents) {
        displayPrices.priceInCents = product.discountedPriceInCents;
        displayPrices.nonDiscountedPriceInCents = product.priceInCents;
    }
    return displayPrices;
};
const getProducts = (productTable, group) => {
    if (!group || !productTable) {
        return [];
    }
    const productPrices = group?.productPrices;
    if (!productPrices) {
        return [];
    }
    return productPrices
        .filter((p) => p.productId !== 'prod_OyBCs6CMuHS498') // tmp remove test product from UI
        .map((productPrice) => {
        const displayPrices = getDisplayPrices(productPrice);
        const product = productTable.products[productPrice.productId];
        return {
            priceId: productPrice.priceId ?? '',
            priceInCents: displayPrices.priceInCents,
            nonDiscountedPriceInCents: displayPrices.nonDiscountedPriceInCents,
            productId: productPrice.productId,
            badgeLabel: productPrice.badgeLabel,
            title: product.title,
            description: product.description,
            features: product.features ?? [],
            ctaLabel: productPrice.ctaLabel ?? '',
            highlighted: productPrice.priceId === group.highlightedPriceId,
            priceIntervalLabel: group.priceIntervalLabel ?? '',
            dataId: `${product.title?.toLowerCase().replace(' ', '_')}-${group.title.toLowerCase()}`,
        };
    });
};
exports.getProducts = getProducts;
const useSelectPlan = () => {
    const { teamId } = (0, react_router_1.useParams)();
    const { search } = (0, react_router_1.useLocation)();
    const urlParams = new URLSearchParams(search);
    const checkoutContext = urlParams?.get('checkoutContext') || api_1.CheckoutContext.ONBOARDING;
    const [group, setGroup] = React.useState();
    const [productTable, setProductTable] = React.useState();
    const [selectedId, setSelectedId] = React.useState(null);
    const { isProcessing, makeRequest } = (0, useRequest_1.useRequest)();
    const [loaded, setLoaded] = React.useState(false);
    const couponId = urlParams.get('coupon') || undefined;
    const fetchPlans = async () => {
        if (!teamId) {
            setProductTable(mocks_1.getPlansResponse.productTable);
            return;
        }
        const { data } = await makeRequest(() => api_1.TeamService.getPlans(+teamId, couponId));
        setProductTable(data?.productTable);
        setGroup(data?.productTable?.groups?.[0]);
        setLoaded(true);
    };
    const choosePlan = async (priceId) => {
        if (!teamId) {
            return;
        }
        setSelectedId(priceId);
        const urlParams = new URLSearchParams(window.location.search);
        const avoidRedirect = urlParams.get('avoid_stripe_redirect') === 'true';
        const coupon = urlParams.get('coupon');
        const checkoutSessionOptions = {
            priceId,
            checkoutContext,
        };
        if (avoidRedirect) {
            checkoutSessionOptions.removeBackButton = true;
        }
        if (coupon) {
            checkoutSessionOptions.coupon = coupon;
        }
        const { data } = await makeRequest(() => api_1.TeamService.createCheckoutSession(+teamId, checkoutSessionOptions));
        if (data?.checkoutUrl) {
            // @ts-ignore
            if (window?.webkit?.messageHandlers?.webCheckoutObserver) {
                // @ts-ignore
                window.webkit.messageHandlers.webCheckoutObserver.postMessage({
                    event: 'planSelected',
                    payload: {
                        url: data.checkoutUrl,
                        avoid_stripe_redirect: avoidRedirect,
                    },
                });
            }
            if (!avoidRedirect) {
                // redirect to checkout page
                (0, utils_1.redirectTo)(data.checkoutUrl);
            }
        }
    };
    React.useEffect(() => {
        fetchPlans();
    }, []);
    const groupItems = productTable?.groups?.map((g) => ({
        // @ts-ignore
        label: g.title,
        // @ts-ignore
        value: g.frequency,
    }));
    const products = productTable && group ? (0, exports.getProducts)(productTable, group) : [];
    const setFrequency = (frequency) => {
        const newGroup = productTable?.groups?.find(
        // @ts-ignore
        (g) => g.frequency === frequency);
        newGroup && setGroup(newGroup);
    };
    const isTrial = group?.productPrices.every((p) => p.trialLengthInDays && p.trialLengthInDays > 0);
    const basicAvailable = products.some((product) => product.dataId.toLowerCase().includes('basic'));
    return {
        products,
        group,
        setFrequency,
        groupItems,
        teamId,
        choosePlan,
        isProcessing,
        selectedId,
        isTrial,
        basicAvailable,
        loaded,
        checkoutContext,
    };
};
exports.useSelectPlan = useSelectPlan;
